(() => {
  if (customElements.get('kiblem-cod')) return;
  class KiblemCod extends HTMLElement {
    connectedCallback() {
      this.controller = new AbortController();
      const { signal } = this.controller;
      this.core = window.KiblemCodCore;
      this.cities = window.KiblemCities || {};
      this.dialog = this.querySelector('dialog');
      this.form = this.querySelector('form');
      this.step = 0;
      this.pending = null;
      this.busy = false;
      this.completed = false;
      this.offer = this.querySelector('[data-cod-exit-offer]');
      this.body = this.querySelector('.kiblem-cod-body');
      this.originalTitle = this.dialog.getAttribute('aria-labelledby');
      this.offerShown = false;
      this.offerAccepted = false;
      try {
        this.offerAccepted = sessionStorage.getItem('kiblem-exit5-accepted') === '1';
      } catch { /* The accepted discount remains available in memory when storage is unavailable. */ }
      this.live = this.dataset.enabled === 'true' && this.validEndpoint(this.dataset.endpoint);
      this.querySelector('[data-cod-preview]').hidden = this.live;
      this.paytrEndpoint = this.dataset.paytrEndpoint;
      this.cardLive = this.validEndpoint(this.paytrEndpoint) && /^[0-9]{6,20}$/.test(this.dataset.chairVariant || '');
      this.querySelector('[data-cod-pay]').hidden = !this.cardLive;
      this.loadPrices();
      const owner = this.closest('kiblem-landing');
      owner.addEventListener('click', (event) => {
        const trigger = event.target.closest('[data-kiblem-open-order], [data-kiblem-sticky] a, .kiblem-header-link, [data-kiblem-cta]');
        if (!trigger) return;
        event.preventDefault();
        this.offerShown = false;
        this.opener = trigger;
        this.dialog.showModal();
        window.KiblemMeta?.track('AddToCart', this.core.total(this.values().upsell, this.offerAccepted, this.values().quantity) / 100, `cart-${crypto.randomUUID()}`, 'cod-cart');
        this.previousOverflow = document.documentElement.style.overflow;
        document.documentElement.style.overflow = 'hidden';
      }, { signal });
      this.querySelectorAll('[data-cod-close]').forEach((button) => button.addEventListener('click', () => this.requestClose(), { signal }));
      this.dialog.addEventListener('cancel', (event) => {
        event.preventDefault();
        this.requestClose();
      }, { signal });
      this.querySelector('[data-cod-offer-accept]').addEventListener('click', () => {
        this.offerAccepted = true;
        try { sessionStorage.setItem('kiblem-exit5-accepted', '1'); } catch { /* No personal information is stored. */ }
        this.restoreOrder();
        this.showStep(this.step);
      }, { signal });
      this.querySelector('[data-cod-offer-decline]').addEventListener('click', () => this.dialog.close(), { signal });
      this.dialog.addEventListener('close', () => {
        this.restoreOrder();
        document.documentElement.style.overflow = this.previousOverflow ?? '';
        this.opener?.focus();
      }, { signal });
      this.querySelector('[data-cod-next]').addEventListener('click', () => {
        this.showStep(this.step + 1);
      }, { signal });
      this.querySelector('[data-cod-back]').addEventListener('click', () => this.showStep(this.step - 1), { signal });
      const province = this.form.elements.il;
      Object.keys(this.cities).forEach((name) => province.add(new Option(name, name)));
      province.addEventListener('change', () => {
        const district = this.form.elements.ilce;
        district.replaceChildren(new Option(province.value ? 'İlçe seçin' : 'Önce il seçin', ''));
        (this.cities[province.value] || []).forEach((name) => district.add(new Option(name, name)));
        district.disabled = !province.value;
      }, { signal });
      this.form.addEventListener('change', () => this.sync(), { signal });
      this.form.addEventListener('click', (event) => {
        const button = event.target.closest('[data-cod-qty]');
        if (!button || this.busy || this.pending || this.completed) return;
        const input = this.form.elements.quantity;
        input.value = String(Math.max(1, Math.min(this.core.MAX_QTY, this.core.qty(input.value) + Number(button.dataset.codQty))));
        this.sync();
      }, { signal });
      this.form.addEventListener('input', (event) => {
        if (event.target.getAttribute('aria-invalid') === 'true') {
          const errors = this.core.validate(this.values(), this.cities);
          if (!errors[event.target.name]) this.setError(event.target.name, '');
        }
      }, { signal });
      this.form.addEventListener('submit', (event) => { event.preventDefault(); this.submit(); }, { signal });
      this.sync();
      this.handleReturn();
    }
    restoreOrder() {
      this.offer.hidden = true;
      this.body.hidden = false;
      this.dialog.setAttribute('aria-labelledby', this.originalTitle);
    }
    requestClose() {
      if (!this.offerShown && !this.offerAccepted && !this.busy && !this.pending && !this.completed) {
        this.offerShown = true;
        this.body.hidden = true;
        this.offer.hidden = false;
        this.dialog.setAttribute('aria-labelledby', this.offer.querySelector('h2').id);
        this.querySelector('[data-cod-offer-accept]').focus();
        return;
      }
      this.dialog.close();
    }
    validEndpoint(value) {
      try { const url = new URL(value); return url.protocol === 'https:' && !url.username && !url.password; } catch { return false; }
    }
    values() {
      const values = Object.fromEntries(new FormData(this.form));
      values.payment = this.form.elements.payment_choice?.value === 'card' && this.cardLive ? 'card' : 'cod';
      values.payment_method = values.payment === 'card' ? 'card' : 'cash_or_card';
      values.variant_chair = this.dataset.chairVariant;
      values.variant_ravza = this.dataset.ravzaVariant;
      values.exit_offer = this.offerAccepted;
      values.upsell = this.form.elements.upsell.checked;
      values.quantity = this.core.qty(this.form.elements.quantity?.value);
      return values;
    }
    setError(name, message) {
      const error = this.querySelector(`[data-error="${name}"]`);
      if (error) error.textContent = message;
      this.form.querySelectorAll(`[name="${name}"]`).forEach((input) => {
        input.setAttribute('aria-invalid', String(Boolean(message)));
        if (error) input.setAttribute('aria-describedby', error.id);
      });
    }
    validate() {
      const errors = this.core.validate(this.values(), this.cities);
      ['first_name', 'last_name', 'phone', 'email', 'il', 'ilce', 'address', 'note'].forEach((name) => this.setError(name, errors[name] || ''));
      const names = Object.keys(errors);
      if (names.length) {
        this.showStep(1);
        this.form.querySelector(`[name="${names[0]}"]`)?.focus();
      }
      return !names.length;
    }
    showStep(step) {
      if (this.pending || this.busy || this.completed) return;
      this.step = Math.max(0, Math.min(1, step));
      this.querySelectorAll('[data-cod-panel]').forEach((panel) => { panel.hidden = Number(panel.dataset.codPanel) !== this.step; });
      this.querySelectorAll('[data-cod-progress]').forEach((item) => {
        if (Number(item.dataset.codProgress) === this.step) item.setAttribute('aria-current', 'step');
        else item.removeAttribute('aria-current');
      });
      this.querySelector('[data-cod-back]').hidden = this.step === 0;
      this.querySelector('[data-cod-next]').hidden = this.step === 1;
      this.querySelector('[data-cod-submit]').hidden = this.step !== 1;
      this.querySelector('[data-cod-next]').textContent = 'Teslimat Bilgilerine Geç';
      this.querySelector('[data-cod-submit]').textContent = this.submitLabel();
      this.querySelector('[data-cod-status]').textContent = '';
      this.sync();
      const panel = this.querySelector(`[data-cod-panel="${this.step}"]`);
      if (this.step === 1) window.KiblemMeta?.track('InitiateCheckout', this.core.total(this.values().upsell, this.offerAccepted, this.values().quantity) / 100, `checkout-${crypto.randomUUID()}`, 'cod-checkout');
      panel.tabIndex = -1;
      panel.focus({ preventScroll: true });
      panel.scrollIntoView({ block: 'start', behavior: 'instant' });
    }
    sync() {
      const values = this.values();
      this.querySelector('[data-cod-total]').textContent = this.core.format(this.core.total(values.upsell, values.exit_offer, values.quantity));
      this.querySelector('[data-cod-discount-row]').hidden = !this.offerAccepted;
      this.querySelector('[data-cod-discount-notice]').hidden = !this.offerAccepted;
      this.querySelector('[data-cod-upsell-row]').hidden = !values.upsell;
      this.querySelector('[data-cod-selection]').textContent = values.upsell ? 'Eklendi · Kaldırmak için dokunun' : 'Seccadeyi ekle';
      const count = values.quantity, c = this.core;
      this.querySelector('[data-cod-chair-price]').textContent = c.format(c.catalog.chair * count);
      this.querySelector('[data-cod-chair-label]').textContent = `Namaz sandalyesi · ${count} adet`;
      this.querySelector('[data-cod-chair-total]').textContent = c.format(c.catalog.chair * count);
      this.querySelector('[data-cod-discount-amount]').textContent = `−${c.format(c.discount(true) * count)}`;
      this.querySelector('[data-cod-discount-saving]').textContent = c.format(c.discount(true) * count);
      this.querySelectorAll('[data-cod-qty]').forEach((b) => { b.disabled = Number(b.dataset.codQty) < 0 ? count <= 1 : count >= c.MAX_QTY; });
      const card = values.payment === 'card';
      const emailField = this.querySelector('[data-cod-email]');
      emailField.hidden = true;
      emailField.querySelector('input').required = false;
      if (!card) this.setError('email', '');
      this.querySelector('[data-cod-pay-notice]').textContent = card
        ? 'Siparişi onayladığınızda iyzico güvenli ödeme sayfasına yönlendirilirsiniz. Ödemenin tamamı kartınızdan şimdi alınır.'
        : 'Kapıda nakit veya kredi kartıyla ödeyebilirsiniz. Ödemenin tamamı teslimatta alınır.';
      this.querySelector('[data-cod-total-label]').textContent = card ? 'Kartla ödenecek toplam' : 'Kapıda ödenecek toplam';
      if (!this.busy && !this.pending && this.step === 1) this.querySelector('[data-cod-submit]').textContent = this.submitLabel();
    }
    lock(locked) {
      this.form.querySelectorAll('input, select, textarea, [data-cod-back]').forEach((input) => { input.disabled = locked; });
      if (!locked) this.form.elements.ilce.disabled = !this.form.elements.il.value;
    }
    async submit() {
      if (this.busy || this.completed) return;
      if (this.step === 0) {
        this.showStep(1);
        return;
      }
      const status = this.querySelector('[data-cod-status]');
      if (!this.pending && this.values().payment === 'card') {
        if (this.validate()) await this.submitCard(status);
        return;
      }
      if (!this.pending && !this.validate()) return;
      if (!this.live) {
        status.textContent = 'Form kontrolü tamamlandı. Önizleme modundasınız; bilgileriniz gönderilmedi ve sipariş oluşturulmadı.';
        return;
      }
      if (!this.pending) {
        this.pending = this.core.buildPayload(this.values(), crypto.randomUUID());
        this.pending.tracking = window.KiblemMeta?.context() || { marketing_consent: false };
      }
      // A retry keeps its order identity but must respect a later consent withdrawal.
      if (this.pending.tracking.marketing_consent && window.KiblemMeta?.context().marketing_consent !== true) this.pending.tracking = { marketing_consent: false };
      this.lock(true);
      this.busy = true;
      this.form.setAttribute('aria-busy', 'true');
      const submit = this.querySelector('[data-cod-submit]');
      submit.disabled = true;
      submit.textContent = 'Siparişiniz gönderiliyor…';
      status.textContent = '';
      this.request = new AbortController();
      const timer = setTimeout(() => this.request.abort(), 25000);
      try {
        const response = await fetch(this.dataset.endpoint, {
          method: 'POST', headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(this.pending), signal: this.request.signal, credentials: 'omit', redirect: 'error'
        });
        const result = await response.json();
        if (response.ok && result.ok === true && result.event_id === this.pending.event_id && result.order?.id && result.order?.name) {
          this.completed = true;
          if (this.pending.tracking.marketing_consent === true) window.KiblemMeta?.track('Purchase', this.pending.total_minor / 100, this.pending.event_id);
          this.form.hidden = true;
          this.querySelector('[data-cod-confirmation]').textContent = `Sipariş numaranız: ${String(result.order.name)} · ${this.core.format(this.pending.total_minor)}`;
          const done = this.querySelector('.kiblem-cod-done');
          done.hidden = false;
          done.focus();
          this.querySelector('.kiblem-cod-progress').hidden = true;
        } else if (result.ok === false && result.status === 'rejected' && result.event_id === this.pending.event_id) {
          this.pending = null;
          this.lock(false);
          status.textContent = 'Sipariş oluşturulmadı. Bilgilerinizi kontrol edip tekrar deneyin.';
        } else {
          throw new Error('Unconfirmed order');
        }
      } catch {
        status.textContent = 'Sipariş sonucu henüz doğrulanamadı. Yeniden denediğinizde aynı sipariş numarasıyla kontrol edilir; bilgileriniz tekrar sipariş oluşturmak için değiştirilmez.';
      } finally {
        clearTimeout(timer);
        this.busy = false;
        this.form.setAttribute('aria-busy', 'false');
        submit.disabled = false;
        submit.textContent = this.pending ? 'Sipariş Durumunu Yeniden Kontrol Et' : 'Siparişi Onayla';
      }
    }
    async loadPrices() {
      if (!this.cardLive) return;
      const chairId = this.dataset.chairVariant, ravzaId = this.dataset.ravzaVariant;
      const ids = [chairId, ravzaId].filter((v) => /^[0-9]{6,20}$/.test(v || ''));
      try {
        const response = await fetch(`${this.paytrEndpoint.replace(/\/init$/, '/fiyatlar')}?v=${ids.join(',')}`, { credentials: 'omit' });
        const data = await response.json();
        const chair = data.variants?.[chairId]?.price_minor;
        if (!Number.isInteger(chair)) return;
        const before = { ...this.core.catalog };
        this.core.setPrices(chair, data.variants?.[ravzaId]?.price_minor);
        this.retext(before);
        this.sync();
      } catch { /* Okunamazsa sayfadaki fiyat kalır; sunucu uyuşmazlıkta ödemeyi zaten başlatmaz. */ }
    }
    retext(before) {
      // ponytail: sayfadaki tutar metinlerini birebir değiştirir; tutar iki elemana bölünmüşse kaçar (şu an yok).
      const c = this.core, after = c.catalog;
      const disc = (x) => Math.round(x * 5 / 100);
      const pairs = [[before.chair - disc(before.chair), after.chair - disc(after.chair)], [disc(before.chair), disc(after.chair)],
        [before.chair, after.chair], [before.ravza, after.ravza]]
        .map(([a, b]) => [c.format(a), c.format(b)]).filter(([a, b]) => a !== b);
      if (!pairs.length) return;
      const walker = document.createTreeWalker(this.closest('kiblem-landing') || document.body, NodeFilter.SHOW_TEXT);
      for (let node = walker.nextNode(); node; node = walker.nextNode()) {
        let value = node.nodeValue;
        for (const [a, b] of pairs) value = value.split(a).join(b);
        if (value !== node.nodeValue) node.nodeValue = value;
      }
    }
    submitLabel() {
      if (this.values().payment === 'card') return 'Kartla Güvenli Öde';
      return this.live ? 'Siparişi Onayla' : 'Formu Kontrol Et';
    }
    handleReturn() {
      const params = new URLSearchParams(window.location.search);
      const result = params.get('odeme');
      if (result !== 'basarili' && result !== 'hata') return;
      params.delete('odeme');
      const query = params.toString();
      history.replaceState(null, '', window.location.pathname + (query ? `?${query}` : '') + window.location.hash);
      this.previousOverflow = document.documentElement.style.overflow;
      document.documentElement.style.overflow = 'hidden';
      this.dialog.showModal();
      if (result === 'basarili') {
        this.completed = true;
        this.form.hidden = true;
        this.querySelector('.kiblem-cod-progress').hidden = true;
        let bought = null;
        try { bought = JSON.parse(sessionStorage.getItem('kiblem-card-purchase') || 'null'); sessionStorage.removeItem('kiblem-card-purchase'); } catch { bought = null; }
        const paid = bought && Number.isInteger(bought.value) && bought.value > 0 ? ` (${this.core.format(bought.value)})` : '';
        this.querySelector('[data-cod-confirmation]').textContent = `Kartla ödemeniz alındı${paid}. Siparişiniz oluşturuluyor ve 3 iş günü içinde kargoya verilir.`;
        if (paid) this.trackPurchase(bought.value / 100, String(bought.id));
        this.querySelector('[data-cod-done-pay]').textContent = 'Ödemenin tamamı kartınızdan alındı; teslimatta ek ödeme yapmazsınız.';
        const done = this.querySelector('.kiblem-cod-done');
        done.hidden = false;
        done.focus();
        return;
      }
      this.form.elements.payment_choice.value = 'card';
      this.showStep(1);
      this.querySelector('[data-cod-status]').textContent = 'Ödeme tamamlanamadı. Bilgilerinizi kontrol edip tekrar deneyebilir ya da kapıda ödemeyi seçebilirsiniz.';
    }
    trackPurchase(value, eventId) {
      // İzin API'si yüklenmeden track() olayı sessizce düşürür → izin hazır olunca gönder (track aynı id'yi bir kez yollar).
      const fire = () => window.KiblemMeta?.track('Purchase', value, eventId);
      document.addEventListener('visitorConsentCollected', fire, { once: true });
      if (window.Shopify?.customerPrivacy) fire();
      else window.Shopify?.loadFeatures?.([{ name: 'consent-tracking-api', version: '0.1' }], (error) => { if (!error) fire(); });
    }
    async submitCard(status) {
      const submit = this.querySelector('[data-cod-submit]');
      if (!this.cardLive) {
        status.textContent = 'Kartla ödeme şu an kullanılamıyor. Kapıda ödemeyi seçebilirsiniz.';
        return;
      }
      // Her denemede yeni event_id: sunucu aynı numarayla ikinci ödemeyi başlatmaz (409).
      const payload = this.core.buildPayload(this.values(), crypto.randomUUID());
      payload.return_path = window.location.pathname;
      this.lock(true);
      this.busy = true;
      this.form.setAttribute('aria-busy', 'true');
      submit.disabled = true;
      submit.textContent = 'Güvenli ödeme sayfası hazırlanıyor…';
      status.textContent = '';
      const request = new AbortController();
      const timer = setTimeout(() => request.abort(), 25000);
      try {
        const response = await fetch(this.paytrEndpoint, {
          method: 'POST', headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(payload), signal: request.signal, credentials: 'omit', redirect: 'error'
        });
        const result = await response.json();
        if (response.ok && result.ok === true && result.event_id === payload.event_id && typeof result.paymentPageUrl === 'string' && /(^|\.)iyzipay\.com$/.test(new URL(result.paymentPageUrl).hostname)) {
          try { sessionStorage.setItem('kiblem-card-purchase', JSON.stringify({ id: payload.event_id, value: payload.total_minor })); } catch { /* ölçüm opsiyonel */ }
          window.location.assign(result.paymentPageUrl);
          return;
        }
        status.textContent = result.status === 'rejected'
          ? (typeof result.message === 'string' && result.message.length < 120 ? result.message : 'Bilgilerinizi kontrol edip tekrar deneyin.')
          : 'Ödeme sayfası açılamadı. Lütfen tekrar deneyin ya da kapıda ödemeyi seçin.';
      } catch {
        status.textContent = 'Ödeme sayfası açılamadı. Lütfen tekrar deneyin ya da kapıda ödemeyi seçin.';
      } finally {
        clearTimeout(timer);
      }
      this.busy = false;
      this.form.setAttribute('aria-busy', 'false');
      this.lock(false);
      submit.disabled = false;
      submit.textContent = this.submitLabel();
    }
    disconnectedCallback() {
      this.controller?.abort();
      this.request?.abort();
      if (this.dialog?.open) {
        this.dialog.close();
        document.documentElement.style.overflow = this.previousOverflow ?? '';
      }
    }
  }
  customElements.define('kiblem-cod', KiblemCod);
})();
